import { render, staticRenderFns } from "./our-first-10-years.vue?vue&type=template&id=4725d0a9&scoped=true&"
import script from "./our-first-10-years.vue?vue&type=script&lang=js&"
export * from "./our-first-10-years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725d0a9",
  null
  
)

export default component.exports